import React, { type FC, useMemo } from "react";
import { AppRoutes, getRoute, ModuleSubGroups } from "@domain/routing/routeConstants";
import { FormattedMessage } from "react-intl";
import { GQL } from "@binale-tech/shared";
import { useLocation } from "react-router-dom";
import { ModuleNav, type NavItem } from "./ModuleNav";

type Props = { isAZ: boolean; onOpenSettings: (pk: GQL.IProductKey) => void };
export const ModuleERLinks: FC<Props> = ({ isAZ, onOpenSettings }) => {
    const { pathname = "" } = useLocation();

    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(() => {
        const subGroup = isAZ ? ModuleSubGroups.ErA : ModuleSubGroups.ER;

        const oposRoute = getRoute(AppRoutes.invoiceAnalysisOpos, { subGroup });
        const avisRoute = getRoute(AppRoutes.invoiceAnalysisAvis, { subGroup });
        const falligkeitRoute = getRoute(AppRoutes.invoiceAnalysisFalligkeit, { subGroup });
        const festschreibungRoute = getRoute(AppRoutes.invoiceFestschreibung, { subGroup });
        const title = isAZ ? (
            <FormattedMessage id="app.titles.ER_A" />
        ) : (
            <FormattedMessage id="app.titles.ER.rechnungen" />
        );

        return [
            {
                key: "ERProducts",
                label: title,
                children: [
                    {
                        key: getRoute(AppRoutes.invoiceModule, { subGroup: ModuleSubGroups.ER }),
                        to: getRoute(AppRoutes.invoiceModule, { subGroup: ModuleSubGroups.ER }),
                        label: <FormattedMessage id="app.titles.ER.rechnungen" />,
                    },
                    {
                        key: getRoute(AppRoutes.invoiceModule, { subGroup: ModuleSubGroups.ErA }),
                        to: getRoute(AppRoutes.invoiceModule, { subGroup: ModuleSubGroups.ErA }),
                        label: <FormattedMessage id="app.titles.ER_A" />,
                    },
                ],
            },
            {
                key: "Tools",
                label: <FormattedMessage id="app.titles.ER.auswertung" />,
                children: [
                    { key: oposRoute, to: oposRoute, label: "OPOS" },
                    { key: avisRoute, to: avisRoute, label: <FormattedMessage id="app.titles.ER.za" /> },
                    {
                        key: falligkeitRoute,
                        to: falligkeitRoute,
                        label: <FormattedMessage id="app.fields.falligkeit" />,
                    },
                    {
                        key: festschreibungRoute,
                        to: festschreibungRoute,
                        label: <FormattedMessage id="app.titles.ER.festschreibung" />,
                    },
                ],
            },
            {
                key: getRoute(AppRoutes.invoiceTemplates, {
                    subGroup: isAZ ? ModuleSubGroups.ErA : ModuleSubGroups.ER,
                }),
                to: getRoute(AppRoutes.invoiceTemplates, { subGroup: isAZ ? ModuleSubGroups.ErA : ModuleSubGroups.ER }),
                label: <FormattedMessage id="app.titles.templates" />,
            },
            {
                key: "settings",
                onClick: () => onOpenSettings(isAZ ? GQL.IProductKey.ErA : GQL.IProductKey.Er),
                label: <FormattedMessage id="app.titles.settings" />,
            },
        ];
    }, [isAZ, onOpenSettings]);

    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
